import React from 'react';
import Aurora from '../components/Aurora';
import './WaitingPage.css';

const WaitingPage: React.FC = () => {
  return (
    <div className="waiting-page">
      <div className="aurora-background">
        <Aurora
          colorStops={["#7d19ff", "#a560ff", "#801eff"]}
          blend={0.5}
          amplitude={1.0}
          speed={0.5}
        />
      </div>
      <div className="waiting-container">
        <div className="logo-section">
          <h1 className="brand-name">SolBlox</h1>
        </div>
        
        <p className="waiting-description">
          Flip. Spin. Win.
        </p>
        
        <a 
          href="https://discord.gg/solblox" 
          target="_blank" 
          rel="noopener noreferrer"
          className="discord-btn"
        >
          Join the Discord
        </a>
      </div>
    </div>
  );
};

export default WaitingPage;